import { enhancedApi } from 'src/api/enhanced-api';

const MAINTENANCE_BANNER =
  'Aufgrund geplanter Wartungsarbeiten steht Ihnen die Plattform im Zeitraum vom 27.03. um 08:00 Uhr bis zum 30.03. um 08:00 Uhr vorübergehend nicht zur Verfügung.';

export const useBanner = () => {
  const { data } = enhancedApi.useGetApiAssociationInfoQuery();

  // TODO: more banner types
  return data?.demoMode ? 'Demo' : undefined;
};
